import styled from "styled-components";

export const Jumbotron = styled.div`
  direction: rtl;
  padding: 3rem 5rem 2rem 3rem;
  border-radius: 20px;
  background-color: #FDFDFE;
  box-shadow: 0 20px 60px 0 rgba(79, 104, 145, 0.1);
  -webkit-box-shadow: 0 20px 60px 0 rgba(79, 104, 145, 0.1);
  -moz-box-shadow: 0 20px 60px 0 rgba(79, 104, 145, 0.1);
  min-height: 596px;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 992px) {
    padding: 2rem 1rem 3rem;
    min-height: unset;
  }
`;
